/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import FeaturesBar from "./FeaturesBar.container";

export default FeaturesBar;
